import debugIt from 'debug'

export const telemetryDebug = debugIt('telemetry:sanity:cli')
